import { FlexContainer, Slide } from '@act/storybook';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';
import { useMobile } from '../../../../utilities/MobileContext';

export const CouldntHaveHappenedSlide = () => {
  const theme = useTheme();
  const { isMobile } = useMobile();

  return (
    <Slide>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        <FlexContainer direction="column" gap={2} alignItems="center">
          {isMobile ? (
            // Mobile: Single paragraph
            <Typography
              variant="headlineLarge"
              fontSize="48px"
              fontWeight="400"
              color="primary.contrastText"
              lineHeight="56px"
            >
              But none of this could have happened if it wasn't for{` `}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.75, duration: 1.25 }}
                style={{ display: 'inline' }}
              >
                <Typography
                  component="span"
                  fontSize="48px"
                  fontWeight="800"
                  color={theme.palette.primaryAccent.main}
                >
                  you
                </Typography>
              </motion.div>
            </Typography>
          ) : (
            // Desktop: Three separate lines
            <>
              <Typography
                variant="headlineLarge"
                fontSize="48px"
                fontWeight="400"
                color="primary.contrastText"
              >
                But none of this could
              </Typography>
              <Typography
                variant="headlineLarge"
                fontSize="48px"
                fontWeight="400"
                color="primary.contrastText"
              >
                have happened if it
              </Typography>
              <Typography
                variant="headlineLarge"
                fontSize="48px"
                fontWeight="400"
                color="primary.contrastText"
                marginTop="-10px"
              >
                wasn't for{` `}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.75, duration: 1.25 }}
                  style={{ display: 'inline' }}
                >
                  <Typography
                    component="span"
                    fontSize="48px"
                    fontWeight="800"
                    color={theme.palette.primaryAccent.main}
                  >
                    you
                  </Typography>
                </motion.div>
              </Typography>
            </>
          )}
        </FlexContainer>
      </motion.div>
    </Slide>
  );
};
